import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import PageHero from '../components/PageHero';
import { IMG } from '../images';
import { AREAS } from '../areas';

const Areas = () => (
  <div>
    <PageHero
      image={IMG.hero}
      position="55% 45%"
      title="Areas We Service"
      subtitle="Based in Eastlakes, Sydney. Working across Sydney and New South Wales."
      minHeight="48vh"
    />
    <section className="section">
      <div className="container">
        <div className="section-header reveal">
          <h2>Rope Access Across Sydney &amp; NSW</h2>
          <p>
            We regularly work in Sydney, Newcastle, Wollongong, the Blue Mountains and surrounding regions. For specialised
            projects, we can travel further. Choose your area to see how we can help.
          </p>
        </div>
        <div className="mini-links" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
          {AREAS.map((a) => (
            <Link key={a.slug} to={`/areas/${a.slug}`} className="mini-link">
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={18} style={{ color: 'var(--safety-orange)' }} aria-hidden="true" /> {a.name}
              </span>
              <ArrowRight size={18} aria-hidden="true" />
            </Link>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <p style={{ marginBottom: '1.25rem', color: 'var(--steel-gray)' }}>Not sure if we cover your location? Just ask.</p>
          <a href="tel:0426920301" className="btn-primary"><Phone size={18} aria-hidden="true" /> Call 0426 920 301</a>
        </div>
      </div>
    </section>
  </div>
);

export default Areas;
